import React from 'react'
import resume from "./assets/resume.pdf"
import './styles/resume.css'
const Resume = () => {
  return (
    <>
    <div className='iframe-container'>
    <iframe src={resume} title="Resume"/>
    </div>
    </>
  )
}

export default Resume